import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

@Injectable({ providedIn: 'root' })
export class PreviewBatchLoaderService {
  public static readonly MAX_BATCH_SIZE = 100;
  private static readonly LOCAL_STORAGE_KEY_PREFIX = 'preview-uuids-';

  private _localStorageService = inject(LocalStorageService);

  public clearUuids(documentType: string): void {
    const key = `${PreviewBatchLoaderService.LOCAL_STORAGE_KEY_PREFIX}${documentType}`;
    this._localStorageService.removeItem(key);
  }

  public retrieveAndClearUuids(documentType: string): string[] | null {
    const key = `${PreviewBatchLoaderService.LOCAL_STORAGE_KEY_PREFIX}${documentType}`;
    const uuids = this._localStorageService.read<string[]>(key);
    if (uuids) {
      this._localStorageService.removeItem(key);
    }
    return uuids;
  }

  public storeUuids(documentType: string, uuids: string[] | null | undefined): void {
    const key = `${PreviewBatchLoaderService.LOCAL_STORAGE_KEY_PREFIX}${documentType}`;
    this._localStorageService.write(key, uuids);
  }
}
